import type { ComponentChildren } from 'preact';
import { T } from '../../styles/tokens';

interface SectionDividerProps {
  title: string;
  open: boolean;
  onToggle: () => void;
  icon?: ComponentChildren;
  badge?: string;
  badgeColor?: string;
  children?: ComponentChildren;
}

export function SectionDivider({ title, open, onToggle, icon, badge, badgeColor, children }: SectionDividerProps) {
  return (
    <>
      <button
        type="button"
        onClick={onToggle}
        style={{
          display: 'flex', alignItems: 'center', gap: 10, width: '100%',
          background: 'none', border: 'none', cursor: 'pointer', padding: '12px 0 8px',
          borderTop: `1px solid ${T.border}`, marginTop: 8,
        }}
      >
        {icon}
        <span style={{ fontSize: 13, fontWeight: 700, color: T.textSecondary, flex: 1, textAlign: 'left' }}>{title}</span>
        {badge && !open && (
          <span style={{
            fontSize: 11, fontWeight: 500, color: badgeColor || T.textSecondary,
            background: badgeColor ? `${badgeColor}15` : T.bgCard,
            padding: '2px 8px', borderRadius: 6, whiteSpace: 'nowrap', maxWidth: 160,
            overflow: 'hidden', textOverflow: 'ellipsis',
          }}>{badge}</span>
        )}
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={T.textSecondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          style={{ transition: 'transform 0.25s ease', transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}>
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>
      {children && open && children}
    </>
  );
}
